import { createSignal, createRoot, createEffect } from 'solid-js';
import { createAccessor } from './create-accessor.js';

function createSubscriber(signal) {
    return function subscribe(fn) {
        return createRoot((dispose) => {
            createEffect(() => fn(signal()));
            return dispose;
        });
    };
}
const storeFactory = (initialValue) => {
    const [signal, setSignal] = createSignal(initialValue);
    function signalSetter(value) {
        setSignal(() => value);
    }
    function signalUpdater(updater) {
        setSignal(updater);
    }
    const accessor = createAccessor(signal);
    const subscribe = createSubscriber(signal);
    accessor.subscribe = subscribe;
    accessor.set = signalSetter;
    accessor.update = signalUpdater;
    return accessor;
};

export { storeFactory };
//# sourceMappingURL=stores.js.map
